import NotExistedErrorIcon from '@/assets/svg/not-existed-error.svg?react';
import { useCalcDocContentPaddingTop } from '@/hooks/useCalcDocContentPaddingTop';
import { useCalcNavbarHeight } from '@/hooks/useCalcNavbarHeight';
import { useCalcNotificationHeight } from '@/hooks/useCalcNotificationHeight';
import { useAppearanceConfigModelStore } from '@/models/appearance-config/appearanceConfig';
import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import { ScreenSize } from '@/shared/constant/ScreenSize';
import { Button } from 'aui';
import { FoxIconRefreshCw01 } from 'aui-biz-icons';
import clsx from 'clsx';

export type ResourceNotFoundContentProps = {
  className?: string;
};

export function ResourceNotFoundContent(props: ResourceNotFoundContentProps) {
  const { className } = props;

  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);
  const navbarHeight = useCalcNavbarHeight();
  const notificationHeight = useCalcNotificationHeight();
  const homeLink = useDocsDataModelStore((x) => x.sidebarTree.homeLink);
  const isMobileSize = useAppearanceConfigModelStore((x) => x.screenSize === ScreenSize.Mobile);
  const docContentPaddingTop = useCalcDocContentPaddingTop();

  return (
    <div
      className="flex w-full items-center justify-center overflow-hidden"
      style={{
        height: isMobileSize
          ? undefined
          : `calc(100vh - ${navbarHeight + notificationHeight + docContentPaddingTop}px)`,
      }}
    >
      <div
        className={clsx(
          'flex w-auto flex-col items-center justify-center max-os:p-5 os:w-[480px]',
          className,
        )}
      >
        <NotExistedErrorIcon />

        <div className="align-center mt-8 flex justify-center text-2xl font-semibold text-color">
          {clientI18n('onlineShare.resource.notExisted.title')}
        </div>

        <div className="align-center mt-2 text-lg font-400 text-secondary">
          {clientI18n('onlineShare.resource.notExisted.subTitle')}
        </div>

        <Button
          type="primary"
          theme="primary"
          className="mt-8"
          onClick={() => {
            window.location.href = homeLink;
          }}
          icon={<FoxIconRefreshCw01 />}
        >
          {clientI18n('onlineShare.resource.notExisted.reload')}
        </Button>
      </div>
    </div>
  );
}
